/**
 * Legacy CustomerFeesApi module — preserved as an empty AngularJS module + type
 * re-exports so existing dependencies keep resolving:
 *   - `app.module.ts` imports `CustomerFeesApiServiceModule` (the AngularJS
 *     module name string) and registers it in the root module.
 *   - The legacy `acme.common.service.customerFeesApi` AngularJS module is still
 *     declared as a dep of `acme.common.service.api`.
 *
 * The real implementation now lives at:
 *   apps/b2b-frontend/app/core/api/customer-fees/customer-fees-api.service.ts
 */
import angular from "angular";

export type {
  CustomerFeeConfig,
  CustomerFeesApiService,
} from "@ng/core/api/customer-fees/customer-fees-api.service";

export const CustomerFeesApiServiceModule = angular.module(
  "acme.common.service.customerFeesApi",
  [],
).name;
